export interface Option<T = string | number> {
  label: string;  // What the user SEES (e.g., "Tech Lead")
  value: T;       // What the code SAVES (e.g., "TECH_LEAD" or 101)
}


export interface targetRoleRequest {
  targetRole: string;
}

export interface targetRoleResponse {
  id: string;
  targetRole: string;
  createdAt: string;
  updatedAt: string;
}


export interface roleLevelRequest {
  roleLevel: string;
}

export interface roleLevelResponse {
  id: string;
  roleLevel: string;
  createdAt: string;
  updatedAt: string;
}



export interface architectureExperienceRequest {
  architectureExperience: string;
}

export interface architectureExperienceResponse {
  id: string;
  architectureExperience: string;
  createdAt: string;
  updatedAt: string;
}



export interface businessImpactTypeRequest {
  businessImpactType: string;
}

export interface businessImpactTypeResponse {
  id: string;
  businessImpactType: string;
  createdAt: string;
  updatedAt: string;
}


export interface TeamSizeLevelsRequest {
  teamSizeLevel: string;
}

export interface TeamSizeLevelsResponse {
  id: string;
  teamSizeLevel: string;
  createdAt: string;
  updatedAt: string;
}

export interface TechnologyStackRequest {
  technologyStack: string;
}

export interface TechnologyStackResponse {
  id: string;
  technologyStack: string;
  createdAt: string;
  updatedAt: string;
}


export interface CoreExpertiseRequest {
  coreExpertise: string;
}

export interface CoreExpertiseResponse {
  id: string;
  coreExpertise: string;
  createdAt: string;
  updatedAt: string;
}



export interface DomainExpertiseRequest {
  domainExpertise: string;
}

export interface DomainExpertiseResponse {
  id: string;
  domainExpertise: string;
  createdAt: string;
  updatedAt: string;
}



export interface decisionSpeedRequest {
  decisionSpeed: string;
}

export interface decisionSpeedResponse {
  id: string;
  decisionSpeed: string;
  createdAt: string;
  updatedAt: string;
}


export interface hiringAuthorityRequest {
  hiringAuthority: string;
}

export interface hiringAuthorityResponse {
  id: string;
  hiringAuthority: string;
  createdAt: string;
  updatedAt: string;
}


export interface ownerShipLevelRequest {
  ownerShipLevel: string;
}

export interface ownerShipLevelResponse {
  id: string;
  ownerShipLevel: string;
  createdAt: string;
  updatedAt: string;
}




export interface productScaleRequest {
  productScale: string;
}

export interface productScaleResponse {
  id: string;
  productScale: string;
  createdAt: string;
  updatedAt: string;
}


export interface reputationSignalsRequest {
  reputationSignals: string;
}

export interface reputationSignalsResponse {
  id: string;
  reputationSignals: string;
  createdAt: string;
  updatedAt: string;
}



export interface startupRiskPreferenceRequest {
  startupRiskPreference: string;
}

export interface startupRiskPreferenceResponse {
  id: string;
  startupRiskPreference: string;
  createdAt: string;
  updatedAt: string;
}




export interface workFlexibilityRequest {
  workFlexibility: string;
}

export interface workFlexibilityResponse {
  id: string;
  workFlexibility: string;
  createdAt: string;
  updatedAt: string;
}



export interface workStyleRequest {
  workStyle: string;
}

export interface workStyleResponse {
  id: string;
  workStyle: string;
  createdAt: string;
  updatedAt: string;
}


export interface adminMenuRequest {
  adminMenuName : string;
  staus : boolean;
  isDisplayOnUi : boolean;
}

export interface adminMenuResponse {
  id: string;
  adminMenuName : string;
  staus : boolean;
  isDisplayOnUi : boolean;
  createdAt: string;
  updatedAt: string;
}


export interface scoreConfigRequest {
  id?: string;
  fieldName: string;
  scoreType: string;
  weight: number;
  enabled: boolean;
  fieldType: string;
}

export interface scoreConfigResponse {
  id: string;
  fieldName: string;
  scoreType: string;
  weight: number;
  enabled: boolean;
  fieldType: string;
} 

export const initialScoreConfigRequest: scoreConfigRequest = {
  fieldName: "",
  scoreType: "",
  weight: 0,
  enabled: false,
  fieldType: "",
};


export interface scoreValueMappingRequest {
  id?: string;
  fieldName: string;
  fieldValue: string;
  score: number;
}

export interface scoreValueMappingResponse {
  id: string;
  fieldName: string;
  fieldValue: string;
  score: number;
}

export const initialScoreValueMappingRequest: scoreValueMappingRequest = {
  fieldName: "",
  fieldValue: "",
  score: 0,
};


// types/scoreConfig.ts



// 👉 Request DTO
export interface searchConfigRequest {
  fieldName: string;
  label: string;
  filterType: string;
  tier: string;
  enabled: boolean;
  displayOrder: number;
}

// 👉 Response DTO (usually includes id + timestamps etc.)
export interface searchConfigResponse {
  id: string;
  fieldName: string;
  label: string;
  filterType: string;
  tier: string;
  enabled: boolean;
  displayOrder: number;
  createdAt?: string;
  updatedAt?: string;
}

export const initialSearchConfig: searchConfigRequest = {
  fieldName: "",
  label: "",
  filterType: "",
  tier: "",
  enabled: true,
  displayOrder: 1,
};


export interface GenerateInviteRequestDTO {
  userId: string;
}


export interface GenerateInviteResponseDTO {
    inviteCode: string;
    inviteUrl: string;
    expiryAt?: string;
}


export interface JumpStartServicetRequestDTO {
  serviceName: string;
}

export interface JumpStartLogEntryDTO {
  timestamp: string;
  level: string;
  message: string;
}

export interface JumpStartServiceResponseDTO {
  serviceName: string;
  status: string;
  insertedCount: number;
  skippedCount: number;
  durationMs: number;
  logs: JumpStartLogEntryDTO[];
}


export interface cityResponse {
  city: string;
}

export interface domainResponse {
  domainExpertise: string;
}

export interface adminSettingsRequest {
  settingsKey: string;
  settingsValue: string;
  dataType: string;
  description: string;
  isActive: boolean;
}

export interface adminSettingsResponse {
  id: string;
  settingsKey: string;
  settingsValue: string;
  dataType: string;
  description: string;
  isActive: boolean;
  encrypted: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface AdminSettingsCatalogEntry {
  key: string;
  label: string;
  description: string;
  dataType: SystemConfigDataType;
}

export const initialAdminSettingsRequest: adminSettingsRequest = {
  settingsKey: "",
  settingsValue: "",
  dataType: "TEXT",
  description: "",
  isActive: true,
};

export interface adminCreditTopUpRequest {
  userId: string;
  creditType: "INVITE" | "JOB" | "BOTH";
  inviteCredits?: number;
  jobCredits?: number;
}

export interface adminCreditTopUpResponse {
  userId: string;
  role: string;
  inviteCountRemaining: number;
  jobCredits?: number | null;
  message: string;
}

export type SystemConfigDataType = 'STRING' | 'NUMBER' | 'BOOLEAN' | 'SECRET';

export interface SystemConfigEntryResponse {
  key: string;
  label: string;
  description: string;
  dataType: SystemConfigDataType;
  value: string;
  defaultValue: string;
  source: 'DB' | 'PROPERTY';
  secret: boolean;
  encrypted: boolean;
}

export interface SystemConfigCategoryResponse {
  category: string;
  label: string;
  description: string;
  entries: SystemConfigEntryResponse[];
}

export interface SystemConfigUpdateRequest {
  value: string;
}